import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { ResourceAllocationStatus } from '~/types';

export const COMPLETED_RESOURCE_ALLOCATIONS_SUMMARY_QUERY = gql`
  query GetCompletedResourceAllocationsSummary(
    $projectId: String!
    $filter: ProjectResourceAllocationCountFilter!
    $allocationStatusList: [ResourceAllocationStatus!]!
  ) {
    project(projectId: $projectId) {
      id
      allocationsTotals(allocationStatusList: $allocationStatusList) {
        totalHours
      }
      resourceAllocationCount(filter: $filter)
    }
  }
`;

const useCompletedResourceAllocationsSummary = ({ projectId, skip }) => {
  const { data, loading } = useQuery(
    COMPLETED_RESOURCE_ALLOCATIONS_SUMMARY_QUERY,
    {
      variables: {
        projectId,
        allocationStatusList: [ResourceAllocationStatus.Committed],
        filter: {
          allocationStatusList: [ResourceAllocationStatus.Committed]
        }
      },
      skip,
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    projectResourceAllocationsSummary: {
      totalAllocatedHours: data?.project?.allocationsTotals?.totalHours?.toFixed(
        2
      ),
      resourceAllocationCount: data?.project?.resourceAllocationCount
    },
    loading
  };
};

export default useCompletedResourceAllocationsSummary;
